import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
`;

const StyledSpinner = styled.div`
  width: 3rem;
  height: 3rem;
  border: 0.25rem solid white;
  border-top: 0.25rem solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const Spinner = () => {
  return (
    <Overlay>
      <StyledSpinner className="loader" />
    </Overlay>
  );
};

export default Spinner;
